

import '../../../../vendor/assets/javascripts/jquery.fitvids'

export function fitVidsInit() {
  // Target your .container, .wrapper, .post, etc.
  $('.video-responsive').fitVids()
}
